import './styles.scss';

import { faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';

import { Radio } from '../../../../components/radio';
import {
  DATA_DISPLAY_KEYS,
  PortfolioManagementContext,
} from '../../../../providers/portfolio-management';

import { PortfolioButtonCalculate } from './portfolio-button-calculate/portfolio-button-calculate';
import { PortfolioListAggregated } from './portfolio-list-aggregated';
import { PortfolioListPerAccount } from './portfolio-list-per-account';
import { PortfolioRiskSettingsToggles } from './portfolio-risk-settings-toggles';

type PortfolioSidebarContentProps = {
  isPortfolioSidebarOpen: boolean;
};

export const PortfolioSidebarContent = ({
  isPortfolioSidebarOpen,
}: PortfolioSidebarContentProps) => {
  const {
    selectedDataDisplayOption,
    setSelectedDataDisplayOption,
    isPortfolioLoading,
    isPortfolioSidebarSettingsOpen,
    setIsPortfolioSidebarSettingsOpen,
  } = useContext(PortfolioManagementContext);

  const handleOptionChange = (option: string) => {
    setSelectedDataDisplayOption(option);
  };

  const handlePortfolioSidebarSettingsOpen = () => {
    setIsPortfolioSidebarSettingsOpen(true);
  };

  return (
    <div
      className={`portfolio-sidebar-content-container ${isPortfolioSidebarOpen ? 'portfolio-sidebar-content-sidebar-open' : 'portfolio-sidebar-content-sidebar-close'}`}
    >
      <div className="portfolio-sidebar-content-content">
        <div className="portfolio-sidebar-content-data-area">
          <span className="portfolio-sidebar-content-selection-title">Data Display</span>

          <div
            className={`portfolio-sidebar-content-radios-data-display ${isPortfolioSidebarOpen && 'radio-hover'}`}
          >
            <Radio
              label="Aggregated"
              checked={selectedDataDisplayOption === DATA_DISPLAY_KEYS.aggregated}
              onChange={() => handleOptionChange(DATA_DISPLAY_KEYS.aggregated)}
              disabled={isPortfolioLoading}
            />
            <Radio
              label="Per Account"
              checked={selectedDataDisplayOption === DATA_DISPLAY_KEYS.perAccount}
              onChange={() => handleOptionChange(DATA_DISPLAY_KEYS.perAccount)}
              disabled={isPortfolioLoading}
            />
          </div>
        </div>
        {isPortfolioSidebarOpen && (
          <div className="portfolio-sidebar-content-data-area">
            <button
              className={`portfolio-display-settings ${isPortfolioSidebarSettingsOpen ? 'portfolio-display-settings-actived' : ''}`}
              onClick={handlePortfolioSidebarSettingsOpen}
            >
              <span className="portfolio-display-settings-title">Settings</span>
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
          </div>
        )}
        {isPortfolioSidebarOpen && (
          <div className="portfolio-sidebar-content-data-area risk-toggles">
            <PortfolioRiskSettingsToggles />
          </div>
        )}
        <div className="portfolio-sidebar-content-data-area">
          <span className="portfolio-sidebar-content-selection-title">Venue</span>

          {selectedDataDisplayOption === DATA_DISPLAY_KEYS.perAccount ? (
            <PortfolioListPerAccount isPortfolioSidebarOpen={isPortfolioSidebarOpen} />
          ) : (
            <PortfolioListAggregated isPortfolioSidebarOpen={isPortfolioSidebarOpen} />
          )}
        </div>
      </div>
      <PortfolioButtonCalculate isPortfolioSidebarOpen={isPortfolioSidebarOpen} />
    </div>
  );
};
